// import React, { useEffect, useState } from "react";

// import { BrowserRouter, Routes, Route, useNavigate,useLocation } from "react-router-dom";
// import SelectingPage from "./selecting/App";
// import OutputTable from "./outputTable/App";
// import ReportTable from "./reportTable/App";
// import NewMatchPage from "./NewMatchPage";
// import MappingPage from "./hotel_mapping/App";
// import WorkspaceReportTable from "./WorkspaceReportTable";
// import HomePage from "./HomePage";
// import LoginPage from './Login'
// import "./App.css";
// import {
//   TableOutlined,
//   AppstoreAddOutlined,
//   HomeOutlined,
//   BorderlessTableOutlined,
// } from "@ant-design/icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHotel, faTable } from "@fortawesome/free-solid-svg-icons";
// import RenewFollowup from "./RenewFollowup";
// import { Login } from "@mui/icons-material";
// const Sidebar = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="sidebarMain">
//       <div className="tab" onClick={() => navigate("/home")}>
//         {/* <HddOutlined style={{color:"black"}}/> */}
//         <HomeOutlined icon={faHotel} style={{ color: "black" }} />
//       </div>
//       <div className="tab" onClick={() => navigate("/hotelMapping")}>
//         {/* <HddOutlined style={{color:"black"}}/> */}
//         <FontAwesomeIcon icon={faHotel} style={{ color: "black" }} />
//       </div>
//       <div className="tab" onClick={() => navigate("/test")}>
//         <AppstoreAddOutlined style={{ color: "black" }} />
//       </div>
//       <div className="tab" onClick={() => navigate("/outputTable")}>
//         <TableOutlined style={{ color: "black" }} />
//       </div>
//       <div className="tab" onClick={() => navigate("/reportTable")}>
//         <FontAwesomeIcon icon={faTable} style={{ color: "black" }} />
//       </div>
//       <div className="tab" onClick={() => navigate("/workspaceTable")}>
//         <BorderlessTableOutlined style={{ color: "black" }} />
//       </div>
//     </div>
//   );
// };

// if (typeof self === "undefined") {
//   var self = {};
// }

// const App = () => {
//   return (
//     <BrowserRouter>
//       <div className="app-container">
//         <Sidebar />
//         <div className="contentApp">
//           <Routes>
//             <Route path="/" element={<LoginPage/>}/>
//             <Route path="/home" element={<HomePage />} />
//             <Route path="/selecting" element={<SelectingPage />} />
//             <Route path="" element={<OutputTable />} />
//             <Route path="/outputTable" element={<OutputTable />} />
//             <Route path="/renewfollowup" element={<RenewFollowup />} />

//             <Route path="/selecting/:documentId" element={<SelectingPage />} />
//             <Route path="/test/:documentId" element={<NewMatchPage />} />
//             <Route path="/test" element={<NewMatchPage />} />
//             <Route path="/hotelMapping" element={<MappingPage />} />
//             <Route path="/reportTable" element={<ReportTable />} />
//             <Route path="/workspaceTable" element={<WorkspaceReportTable />} />
//             <Route path="/renewfollowup" element={<RenewFollowup />} />
//           </Routes>
//         </div>
//       </div>
//     </BrowserRouter>
//   );
// };

// export default App;

import React from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import SelectingPage from "./selecting/App";
import OutputTable from "./outputTable/App";
import ReportTable from "./reportTable/App";
import NewMatchPage from "./NewMatchPage";
import MappingPage from "./hotel_mapping/App";
import WorkspaceReportTable from "./WorkspaceReportTable";
import HomePage from "./HomePage";
import LoginPage from './Login';
import RenewFollowup from "./RenewFollowup";
import "./App.css";
import {
  TableOutlined,
  AppstoreAddOutlined,
  HomeOutlined,
  BorderlessTableOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotel, faTable } from "@fortawesome/free-solid-svg-icons";
import NewGstinPage from "./AddNewGSTIN";

import InvoiceFollowup from "./InvoiceFollowup";
const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <div className="sidebarMain">
      <div className="tab" onClick={() => navigate("/home")}>
        <HomeOutlined style={{ color: "black" }} />
      </div>
      <div className="tab" onClick={() => navigate("/hotelMapping")}>
        <FontAwesomeIcon icon={faHotel} style={{ color: "black" }} />
      </div>
      <div className="tab" onClick={() => navigate("/test")}>
        <AppstoreAddOutlined style={{ color: "black" }} />
      </div>
      <div className="tab" onClick={() => navigate("/outputTable")}>
        <TableOutlined style={{ color: "black" }} />
      </div>
      <div className="tab" onClick={() => navigate("/reportTable")}>
        <FontAwesomeIcon icon={faTable} style={{ color: "black" }} />
      </div>
      <div className="tab" onClick={() => navigate("/workspaceTable")}>
        <BorderlessTableOutlined style={{ color: "black" }} />
      </div>
    </div>
  );
};

const App = () => {
  const location = useLocation(); // `useLocation` works only inside `BrowserRouter`

  const shouldShowSidebar = location.pathname !== "/";

  return (
    <div className="app-container">
      {shouldShowSidebar && <Sidebar />}
      <div className="contentApp">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/selecting" element={<SelectingPage />} />
          <Route path="/outputTable" element={<OutputTable />} />
          <Route path="/renewfollowup" element={<RenewFollowup />} />
          <Route path="/selecting/:documentId" element={<SelectingPage />} />
          <Route path="/test/:documentId" element={<NewMatchPage />} />
          <Route path="/test" element={<NewMatchPage />} />
          <Route path="/hotelMapping" element={<MappingPage />} />
          <Route path="/reportTable" element={<ReportTable />} />
          <Route path="/workspaceTable" element={<WorkspaceReportTable />} />
          <Route path="/addGstin" element={<NewGstinPage />} />
          <Route path="/invoicefollowup" element={<InvoiceFollowup />} />
        </Routes>
      </div>
    </div>
  );
};

const AppWithRouter = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default AppWithRouter;


